<script lang="ts">
  import {
    getPlatformIcon,
    getSocialColor,
  } from "$lib/components/competition-creation/PreviewWidget"
  import {
    Headphones,
    Phone,
    Link,
    Award,
    Share2,
    Mail,
    Rss,
    BookLock,
    Tickets,
    Zap,
  } from "lucide-svelte"

  let {
    action,
    isRTL,
    iconColor,
    iconBgColor,
    iconBorderRadius = "5px",
  } = $props()

  // Get platform-specific colors if not provided
  const platformColor = getSocialColor(action?.platform || "")
  const defaultIconColor = iconColor || "#ffffff" // White icons on colored backgrounds
  const defaultIconBgColor = iconBgColor || platformColor || "#e5e7eb" // Platform color background with gray fallback
</script>

<div
  class="w-7 h-7 rounded-lg flex items-center justify-center"
  class:mr-2={!isRTL}
  class:ml-0={!isRTL}
>
  {#if action.platform === "Bonus Entries"}
    <Award
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Viral Share"}
    <Share2
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Email Marketing"}
    <Mail
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Podcast"}
    <Headphones
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Blog"}
    <Rss
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Secret Code"}
    <BookLock
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Webpage"}
    <Link
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Bookings / Reservations"}
    <Phone
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Custom"}
    <Zap
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "Coupon"}
    <Tickets
      class="w-7 h-7 p-1.5"
      style="color: {defaultIconColor}; background-color: {defaultIconBgColor}; border-radius: {iconBorderRadius};"
    />
  {:else if action.platform === "App Store"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/appstore.svg"
        alt="App Store"
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "Shopify"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/shopify.svg"
        alt="Shopify"
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "Google Play"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/playstore.svg"
        alt={action.platform}
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "Stripe"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/stripe.png"
        alt="Stripe"
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "Paypal"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/paypal.svg"
        alt="Paypal"
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "Threads"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/threads.svg"
        alt="Threads"
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "Justdial"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/justdial.png"
        alt="Justdial"
        class="w-5 h-5"
      />
    </div>
  {:else if action.platform === "IndiaMART"}
    <div
      class="w-7 h-7 flex items-center justify-center p-1"
      style="border-radius: {iconBorderRadius};"
    >
      <img
        src="https://img.promoamp.com/icons/indiamart.png"
        alt="IndiaMART"
        class="w-5 h-5"
      />
    </div>
  {:else}
    <div
      class="w-[28px] h-[28px] sm:w-7 sm:h-7 rounded flex items-center justify-center action-icon"
      style={`border-radius: ${iconBorderRadius}; ${
        action?.platform
          ? getSocialColor(action.platform.toLowerCase()).includes(
              "linear-gradient",
            )
            ? `background-image: ${getSocialColor(action.platform.toLowerCase())}`
            : `background-color: ${getSocialColor(action.platform.toLowerCase())}`
          : "background-color: #ccc"
      }`}
    >
      <img
        src={getPlatformIcon(action?.platform || "")}
        alt={action?.platform || ""}
        class="w-7 h-7 p-1.5"
      />
    </div>
  {/if}
</div>
